// Lazy-loads forms2.min.js via IntersectionObserver when a Marketo form nears
// the viewport, with a 5s post-load fallback.
(function () {
    if (window.__mkto_loader_scheduled) return;
    window.__mkto_loader_scheduled = true;

    var SCRIPT_URL = "https://get.octopus.com/js/forms2/js/forms2.min.js";
    var OBSERVER_ROOT_MARGIN = "500px 0px";
    var FALLBACK_MS = 5000;

    function scriptAlreadyPresent() {
        return !!document.querySelector('script[src*="forms2.min.js"]');
    }

    function loadMarketoScript() {
        if (scriptAlreadyPresent() || typeof window.MktoForms2 !== "undefined") return;
        var s = document.createElement("script");
        s.src = SCRIPT_URL;
        s.async = true;
        document.body.appendChild(s);
    }

    function observeForms() {
        if (!("IntersectionObserver" in window)) {
            loadMarketoScript();
            return;
        }
        var forms = document.querySelectorAll('form[id^="mktoForm_"]');
        if (forms.length === 0) return;

        var observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                    loadMarketoScript();
                    observer.disconnect();
                    return;
                }
            }
        }, { rootMargin: OBSERVER_ROOT_MARGIN });

        forms.forEach(function (el) { observer.observe(el); });
    }

    function scheduleFallback() {
        setTimeout(loadMarketoScript, FALLBACK_MS);
    }

    function init() {
        observeForms();
        if (document.readyState === "complete") {
            scheduleFallback();
        } else {
            window.addEventListener("load", scheduleFallback, { once: true });
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
